export const DEFAULT_MAP_SETTINGS = {
    snapToGrid: false,
    gridSize: 8,
    autoLayout: true,
    // On by default: a user who dragged a node meant it, and an automatic layout that discards
    // that is the fastest way to lose their trust in the layout button.
    preserveManualPositions: true,
    showMinimap: true,
    connectionAnimations: false,
    readingDirectionArrows: false,
};
/** Does this device hold edits the server has not seen? */
export function hasUnsyncedEdits(map) {
    return map.localRevision > map.serverRevision;
}
export function isInTrash(map) {
    return map.deletedAt !== null;
}
/** How many edits are waiting to be sent. Feeds the save-state derivation. */
export function pendingEditCount(map) {
    return Math.max(0, map.localRevision - map.serverRevision);
}
//# sourceMappingURL=map.js.map